module.exports = __webpack_public_path__ + "img/qrregister.6f9d7a16.jpg";